import React from 'react';
import { Info } from 'lucide-react';
import LocalizedLink from '@/i18n/LocalizedLink';
import {
  EVENT_PAGE_INDEPENDENCE_TITLE,
  EVENT_PAGE_INDEPENDENCE_STATEMENT,
  EVENT_PAGE_INDEPENDENCE_SECONDARY,
} from '@/utils/externalEventLinks';

export const EventPageNotice = () => {
  return (
    <div className="mt-6 max-w-4xl rounded-2xl border border-slate-200 bg-white/95 p-4 text-left shadow-sm" data-testid="event-page-independence-notice">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-slate-100 p-2 text-slate-500">
          <Info className="h-4 w-4" />
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-900" data-testid="event-page-independence-title">
            {EVENT_PAGE_INDEPENDENCE_TITLE}
          </p>
          <p className="mt-1.5 text-sm leading-6 text-slate-700">{EVENT_PAGE_INDEPENDENCE_STATEMENT}</p>
          <p className="mt-1.5 text-sm leading-6 text-slate-700">{EVENT_PAGE_INDEPENDENCE_SECONDARY}</p>
          <LocalizedLink to="/about-our-listings" className="mt-3 inline-flex text-sm font-medium text-orange-700 transition-colors hover:text-orange-800" data-testid="about-listings-inline-link">
            How our listings work
          </LocalizedLink>
        </div>
      </div>
    </div>
  );
};
